import React from "react";
import "../styles.scss";

export default function CharityContainer({ children }) {
  return <div className='rui-charity-block'>{children}</div>;
}
